// Resumen del documento "RESUMEN NORMATIVA COLEGIADOS ICOFCV" (oct-2026).
// Si cambian las cuotas o condiciones hay que actualizar este componente.
export const NormativaSummary = () => {
    return (
        <div className="text-xs text-neutral-500">

            <h3 className="font-medium text-sm text-stone-600 mb-2">1. Tipos de colegiado y cuotas colegiales</h3>
            <div className="mb-3 space-y-2">
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Ejerciente — 190 € / año</p>
                    <p>Pago semestral: 100 € (enero) y 90 € (julio). Modalidad estándar de ejercicio profesional.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">No ejerciente — 47,50 € / año (25 % de la cuota)</p>
                    <p>Pago semestral. Aplicable a quienes no ejercen la profesión.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Honorario — 47,50 € / año (25 % de la cuota)</p>
                    <p>Pago semestral. Para personas en situación de jubilación (voluntaria o forzosa).</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">En suspenso — 0 €</p>
                    <p>Regulado por el Reglamento Disciplinario del ICOFCV. No abonan cuota ni disponen de servicios del colegio.</p>
                </div>
            </div>

            <h3 className="font-medium text-sm text-stone-600 mb-2">2. Cuota de inscripción y reincorporación</h3>
            <div className="mb-3 space-y-2">
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Primera colegiación (alta ordinaria) — 75 €</p>
                    <p>Pago único de inscripción.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Primera colegiación (por traslado) — exento</p>
                    <p>Exención total de la cuota de inscripción.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Reingreso hasta 3 años desde la baja — exento</p>
                    <p>Conserva y reactiva su número original de colegiado.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Reincorporación a partir del 3er año desde la baja — 75 €</p>
                    <p>Pérdida del número colegial anterior (se asignará otro actual) y abono de la cuota de inscripción completa vigente.</p>
                </div>
            </div>

            <h3 className="font-medium text-sm text-stone-600 mb-2">3. Baja colegial</h3>
            <div className="space-y-2">
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Baja ordinaria</p>
                    <p>Sin tiempo mínimo de permanencia.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Baja por traslado</p>
                    <p>Permanencia mínima de 3 a 6 meses desde la fecha de alta (salvo causa de fuerza mayor acreditada).</p>
                    <p className="mt-1">• Prorrateo: devolución de la parte proporcional de la cuota no consumida por meses completos pendientes.</p>
                    <p>• Tasa por traslado prematuro: si el traslado se pide entre los meses de permanencia mínima y los 12 meses iniciales, se aplica una tasa del 50 % de la cuota de inscripción.</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-2">
                    <p className="font-medium text-stone-600">Baja por jubilación</p>
                    <p>Sin tiempo mínimo de permanencia. Prorrateo: devolución de la parte proporcional de la cuota no consumida por meses completos pendientes.</p>
                </div>
            </div>

        </div>
    );
}
